import {
  Box,
  Pagination,
  ListItem,
  ListItemButton,
  ListItemText,
  Drawer,
} from "@mui/material";
import { useState, useEffect, useRef } from "react";
import store from "../../../reducers/store";

import { apiContext, apiDict } from "../../../context/api-v1/api";

import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { normalizeSearchInput } from "../../../utils/utils";
import SearchInput from "../../../components/SearchInput";

export default function MiniArticleList({ id, page, search }) {
  const [blogDatas, setBlogDatas] = useState();
  const [currentPageUrl, setCurrentPageUrl] = useState();
  const [searchContent, setSearchContent] = useState(search);

  const [drawerOpen, setDrawerOpen] = useState(true);
  const [drawerPosition, setDrawerPosition] = useState("absolute");

  const pageRef = useRef({
    pageNum: page,
    prevSearchContent: "",
  });
  const drawerRef = useRef(null);

  let blogPage, blogList;
  if (blogDatas) {
    blogPage = blogDatas.allPage;
    blogList = blogDatas.results;
  }

  useEffect(() => {
    if (
      typeof searchContent !== "undefined" &&
      searchContent !== pageRef.current.prevSearchContent
    ) {
      apiContext(
        apiDict.article +
          `?page=${pageRef.current.pageNum}&search=${searchContent}`,
        "GET",
        setBlogDatas
      );
    } else {
      if (currentPageUrl) {
        apiContext(currentPageUrl, "GET", setBlogDatas);
      } else {
        apiContext(
          apiDict.article + `?page=${pageRef.current.pageNum}`,
          "GET",
          setBlogDatas
        );
      }
    }
  }, [currentPageUrl, searchContent]);

  function handlePageClick(e, v) {
    if (searchContent) {
      setCurrentPageUrl(apiDict.article + `?page=${v}&search=${searchContent}`);
    } else {
      setCurrentPageUrl(apiDict.article + `?page=${v}`);
    }

    pageRef.current.pageNum = v;
  }

  useEffect(() => {
    function handleScroll() {
      const windowTop = window.pageYOffset;
      if (windowTop >= window.innerHeight * 0.36) {
        setDrawerOpen(false);
        setDrawerPosition("fixed");
      } else {
        setDrawerOpen(true);
        setDrawerPosition("absolute");
      }
    }

    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  let drawerStyle;
  if (drawerPosition === "absolute") {
    drawerStyle = {
      position: "absolute",
      left: 20,
      top: "calc(36vh + 120px)",
    };
  } else {
    // const currentTop = drawerRef.current.getBoundingClientRect().top; // 单元格到窗口顶部的高度
    drawerStyle = {
      position: "fixed",
      left: 20,
      top: "calc(16.9vh)", // 2024-10-30 18:09:58 手动测算, 精确还需要标准化所有尺寸, 这样才能更好测算
    };
  }

  return (
    <>
      <Drawer
        anchor="left"
        ref={drawerRef}
        open={drawerOpen}
        sx={{
          zIndex: 2000,
          flexShrink: 0,
          minHeight: "81vh", // 2024-10-30 16:38:51 影响内容不足文档空白页高
          bgcolor: "#f2f2f2",

          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            border: "0",
            bgcolor: "#f2f2f2",
            maxHeight: "70%", // 2024-10-30 16:38:51 影响内容不足文档空白页高
            ...drawerStyle,
          },
        }}
        variant="persistent"
      >
        <Box
          sx={{
            width: "13vw",
            bgcolor: "white",
            padding: "10px",
            borderRadius: "5px",
          }}
        >
          <Box
            sx={{
              mb: "15px",
              mt: "5px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <SearchInput
              inputSx={{
                backgroundColor: "#babec2",
                borderRadius: "6px",
                width: "65%",
                height: "20px",
                fontSize: "0.6rem",

                ".MuiInputBase-input": {
                  padding: "0 5px 0 10px ",
                },
              }}
              placeholder="输入搜索内容"
              defaultValue={searchContent}
              normalize={normalizeSearchInput}
              onSearch={(keyword) => {
                pageRef.current.pageNum = 1;
                pageRef.current.prevSearchContent = searchContent;
                setSearchContent(keyword);
              }}
              buttonColor="third"
              buttonSize="small"
              buttonVariant="outlined"
              buttonSx={{
                color: "third",
                ml: "10px",
                padding: "0",
                width: "50px",
                minWidth: 0,
                fontSize: "0.6rem",
              }}
            />
          </Box>

          <Box sx={{ minHeight: "300px" }}>
            {blogList
              ? blogList.map((v, i) => {
                  const style_ = {};
                  if (v.id === id) {
                    style_.bgcolor = "#e2e2e2";
                  }
                  return (
                    <ListItem
                      key={i}
                      component="div"
                      disablePadding
                      onClick={() => {
                        if (v.id !== id) {
                          store.dispatch({
                            type: "currentArticleDatas",
                            payload: {
                              blogUrl: v.target,
                              blogID: v.id,
                              page: pageRef.current.pageNum,
                              search: searchContent,
                              title: v.title,
                            },
                          });
                        }
                      }}
                    >
                      <ListItemButton
                        sx={{
                          padding: "0 5px",
                          borderRadius: "4px",
                          ...style_,
                        }}
                      >
                        <ListItemText
                          sx={{
                            margin: "3px",
                            ".MuiTypography-root": {
                              fontSize: "0.7rem",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              WordBreak: "keep - all",
                            },
                          }}
                          primary={v.title}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })
              : ""}
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: "10px",
              mb: "5px",
            }}
          >
            <Pagination
              count={blogPage ? blogPage : 1}
              shape="rounded"
              onChange={handlePageClick}
              page={pageRef.current.pageNum}
              siblingCount={0}
              // showFirstButton
              // showLastButton
              color="fourth"
              sx={{
                maxWidth: "100%",
                ".MuiButtonBase-root": {
                  width: "20px",
                  height: "20px",
                  padding: 0,
                  minWidth: 0,
                  fontSize: "0.5rem",
                },
              }}
              size="small"
            />
          </Box>
        </Box>
      </Drawer>
      <KeyboardDoubleArrowRightIcon
        onClick={() => setDrawerOpen(true)}
        sx={{
          position: "fixed",
          left: "0px",
          top: "40%",
          display: drawerOpen ? "none" : "flex",
          color: "#545454",
          cursor: "pointer",
          fontSize: "21px",
        }}
        variant="contained"
      />
    </>
  );
}
